//@module StoreLocatorExtension
define(
	'StoreLocatorExtension'
,   [
		'Location.VenueDetails.View',
		'locator_venue_details_extension.tpl',
		'StoreLocator.List.All.Store.View',
		'underscore'
	]
,   function (
		LocationVenueDetails,
		locator_venue_details_extension_tpl,
		StoreLocatorListAllView,
		_
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			//override the template
			_.extend(LocationVenueDetails.prototype, {
				template: locator_venue_details_extension_tpl
			});

			StoreLocatorListAllView.prototype.getContext = _.wrap(StoreLocatorListAllView.prototype.getContext, function (fn, e) {
				var context = fn.apply(this, _.toArray(arguments).slice(1));
				context.storeImage = this.model.get('storeImage');
				return context;
			})
		}
	};
});
